import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row, Container, Badge, CardTitle, FormGroup, Input, InputGroup } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import moment from 'moment';
// import Flatpickr from "react-flatpickr";

import axios from 'axios';

import { alerShow, dateformat, removeHeaderToken, apiHeader, convertValueFormat } from '../commonFunction'
import '../../assets/scss/style.css'
import Pagination, { bootstrap5PaginationPreset } from 'react-responsive-pagination';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

//i18n
import { withTranslation } from "react-i18next";

const Dashboard = props => {

    //meta title
    document.title = "Withdraw Transactions | Coinosh";
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [isLoaded, setIsLoaded] = useState(false);
    const [listing, setListing] = useState([]);
    const [dateFilter, setDateFilter] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [totalAmount, setTotalAmount] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState("");



    useEffect(() => {
        fetchData();
    }, [])

    const fetchData = async (dates = '', userName = '',accountNumber='', page = 1) => {

        await axios.get(`${BASE_URL}admin/get-withdraw-transactions?dates=` + dates + `&userName=` + userName + `&accountNumber=` + accountNumber+`&page=${page}&limit=${itemsPerPage}`)
            .then(function (response) {

                console.log(response, 'response success ')
                // if (response.data.data.result.length > 0) {
                setListing(response.data.data.result);
                setTotalAmount(response.data.data.totalAmountTransferred);
                //}
                setTotalPages(Math.ceil(response.data.totalPages));
                setIsLoaded(true);

            })
            .catch(function (error) {
                setIsLoaded(true);
                console.log(error, 'error.response error.response')
                alerShow('Error', error.response.data.message, 'error',error.response.data.statusCode == 401);
                // alerShow('Error', error.response, 'error');
            });
    }
    const handleDateEvent = async (event) => {


        if (event.length == 2) {
            let filterDate = [];
            filterDate[0] = moment(event[0]).format('YYYY-MM-DD');
            filterDate[1] = moment(event[1]).add(1, 'days').format('YYYY-MM-DD');

            console.log(filterDate, 'filter date >>>>>>>')
            setDateFilter(filterDate);
            await fetchData(filterDate);
        }
    }

    const handleUserNameEvent = async (event) => {

        setSearchQuery(event.target.value)
        await fetchData(dateFilter, event.target.value,accountNo);

    }
    const handleAccountNumberEvent = async (event) => {

        setAccountNumber(event.target.value)
        await fetchData(dateFilter,searchQuery,event.target.value);

    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(dateFilter, searchQuery, accountNumber, page); // Pass the updated currentPage value to fetchData
      };
      
    const downloadCSV = () => {
        const csvData = [
          ["UserName", "Amount(NGN)", "Commission(NGN)", "Total Received(NGN)", "Bank Name", "Bank Account Number", "Created At"],
          ...listing.map((value) => [
            value.userName,
            parseFloat(value.commissionInNgn) + parseFloat(value.amountTransferred),
            value.commissionInNgn,
            value.amountTransferred,
            value.bankName,
            value.bankAccountNumber,
            moment(value.createdAt).format("YYYY-MM-DD HH:mm:ss"),
          ]),
        ];
      
        const csvContent = "data:text/csv;charset=utf-8," + csvData.map(e => e.join(",")).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "withdraw-transactions.csv");
        document.body.appendChild(link);
        link.click();
      }
      



    return (
        <React.Fragment>

            <div className="page-content margin-custom">
                <Container fluid>
                    {/* Render Breadcrumb */}

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody className="border-bottom py-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <Breadcrumbs
                                            title={props.t("Dashboard")}
                                            breadcrumbItem={props.t("Withdraw Transaction Listing")}
                                        />  
                                        <b>Total Withdraw Amount: <span style={{color:"#556ee6"}}>
                                            {/* {parseFloat(totalAmount).toFixed(2)} NGN */}
                                            {convertValueFormat(parseFloat(totalAmount).toFixed(2))} NGN
                                            </span></b>
                                        <div className="d-flex align-items-center">
                                        <FormGroup className="me-3" style={{}}>
                                                <InputGroup >
                                                    <Input type="text" value={accountNumber} onChange={(e) => handleAccountNumberEvent(e)} placeholder="Search by AccountNo." />
                                                </InputGroup>
                                            </FormGroup>
                                            <FormGroup className="me-3" style={{}}>
                                                <InputGroup >
                                                    <Input type="text" value={searchQuery} onChange={(e) => handleUserNameEvent(e)} placeholder="Search by UserName" />
                                                </InputGroup>
                                            </FormGroup>

                                            <Flatpickr className="form-control d-block mb-3 me-4" style={{ width: '200px', marginRight: '8px' }} onChange={(date) => handleDateEvent(date)} placeholder="Select Dates" options={{ mode: "range", dateFormat: "Y-m-d" }} />
                                            {/* <div className="flex-shrink-0"> */}
                                            {/* <Link to="#!" className="btn btn-light me-1"><i className="mdi mdi-refresh"></i></Link>
                                        </div> */}
                                            <button className="btn btn-primary mb-3" onClick={downloadCSV}>Export to CSV</button>
                                        </div>


                                        {/* <div className="flex-shrink-0">
                                            <Link to="#!" className="btn btn-light me-1"><i className="mdi mdi-refresh"></i></Link>
                                        </div> */}
                                    </div>
                                </CardBody>
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>S. No.</th>
                                                    <th>UserName</th>
                                                    <th>Amount(NGN)</th>
                                                    <th>Commission(NGN)</th>
                                                    <th>Total Received(NGN)</th>
                                                    <th>Bank Name</th>
                                                    <th>Bank Owner Name</th>
                                                    <th>Bank Account Number</th>
                                                    <th>Created At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (!isLoaded) ?
                                                        <Tr>
                                                            <Td colSpan="8"> Loading ... </Td>
                                                        </Tr>
                                                        : (listing) ?
                                                            listing.map((value, ind) => {
                                                                const serialNumber = (currentPage - 1) * itemsPerPage + ind + 1;
                                                                return <Tr key={value._id}>
                                                                    <Td scope="row"> <span className="co-name"> {serialNumber} </span> </Td>
                                                                    <Td> {value.userName}</Td>
                                                                    <Td> 
                                                                        {/* {parseFloat(value.commissionInNgn) + parseFloat(value.amountTransferred)}  */}
                                                                        {convertValueFormat(parseFloat(value.commissionInNgn) + parseFloat(value.amountTransferred))}
                                                                        </Td>
                                                                    <Td> 
                                                                        {/* {value.commissionInNgn}  */}
                                                                        {convertValueFormat(value.commissionInNgn)}
                                                                        </Td>
                                                                    <Td> 
                                                                        {/* {value.amountTransferred}  */}
                                                                        {convertValueFormat(value.amountTransferred)}
                                                                        </Td>
                                                                    <Td> {value.bankName} </Td>
                                                                    <Td> {value.bankOwnerName} </Td>
                                                                    <Td> {value.accountNumber} </Td>
                                                                    <Td> {moment(value.createdAt).format('MMMM D,YY, h:mm:ss a')}</Td>



                                                                </Tr>
                                                            })
                                                            : <Tr> <Td colSpan="6"> No Result Found </Td> </Tr>
                                                }

                                            </tbody>
                                        </Table>
                                        <Pagination
                                            current={currentPage}
                                            total={totalPages} // Replace 'listing' with the appropriate total number of items
                                            itemsPerPage={itemsPerPage}
                                            onPageChange={handlePageChange}
                                            {...bootstrap5PaginationPreset}
                                        />
                                    </div>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Container>
            </div>

        </React.Fragment>
    );
};


Dashboard.propTypes = {
    t: PropTypes.any,
    chartsData: PropTypes.any,
    onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
